import { useRouter } from 'next/navigation';

const useClose = (fallbackPath: string, back = false) => {
  const router = useRouter();

  const onClose = () => {
    if (back) return router.back();

    if (window !== undefined && document.referrer.includes(fallbackPath)) {
      return router.back();
    }

    return router.push(fallbackPath);
  };

  return onClose;
};

export default useClose;
